import { clsx } from "clsx"
import React from "react"
import "./style.scss"

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  loading?: boolean
  color?: "primary" | "secondary"
  variant?: "solid" | "outline" | "text"
  rightIcon?: React.ReactNode
}

export const Button = ({ color = "primary", variant = "solid", rightIcon, ...props }: ButtonProps) => {
  return (
    <button
      {...props}
      className={clsx("custom-button", `custom-button__variant-${variant}`, `custom-button__color-${color}`, props.className)}
    >
      {props.children}
      {rightIcon && <span className="custom-button__icon">{rightIcon}</span>}
      {props.loading && <span className="custom-button__loading">Loading...</span>}
    </button>
  )
}
